import { binarySearch, compare_number, haversineDistance } from './helpers';
const travelTimesData = require('../data/tt_data.json');

export function getTravelTime(dist) {
  if (dist === 0) {
    return { p: 0, s: 0 };
  }

  const result = binarySearch(travelTimesData['dists'], dist, compare_number);

  if (result > 0) {
    return travelTimesData[type][result];
  } else {
    const low_dist = travelTimesData['dists'][-1 * result - 2];
    const high_dist = travelTimesData['dists'][-1 * result - 1];

    const low_ptt = travelTimesData['p'][-1 * result - 2];
    const high_ptt = travelTimesData['p'][-1 * result - 1];
    const pm = (high_ptt - low_ptt) / (high_dist - low_dist);
    const pT = pm * (dist - low_dist) + low_ptt;

    const low_stt = travelTimesData['s'][-1 * result - 2];
    const high_stt = travelTimesData['s'][-1 * result - 1];
    const sm = (high_stt - low_stt) / (high_dist - low_dist);
    const sT = sm * (dist - low_dist) + low_stt;
    return { p: pT, s: sT };
  }
}

export function getSDistFromTime(sT) {
  const result = binarySearch(travelTimesData['s'], sT, compare_number);
  if (result > 0) {
    return travelTimesData['dists'][result];
  } else {
    const low_stt = travelTimesData['s'][-1 * result - 2];
    const high_stt = travelTimesData['s'][-1 * result - 1];
    const low_dist = travelTimesData['dists'][-1 * result - 2];
    const high_dist = travelTimesData['dists'][-1 * result - 1];
    const m = (high_dist - low_dist) / (high_stt - low_stt);
    return m * (sT - low_stt) + low_dist;
  }
}

export function getMaxResidual(x0, y0, unsorted_pTimes, activeStationMarkers) {
  const est_times = [];
  activeStationMarkers.forEach((stationMarker) => {
    const stationLatLon = stationMarker.getLatLng();
    const dist = haversineDistance([x0, y0], [stationLatLon.lng, stationLatLon.lat]);

    est_times.push(getTravelTime(dist / 1000).p);
  });

  const minEstTime = Math.min(...est_times);

  let maxResidual = 0;
  for (let i = 0; i < est_times.length; i++) {
    est_times[i] = est_times[i] - minEstTime;
    maxResidual = Math.max(maxResidual, Math.abs(est_times[i] - unsorted_pTimes[i]));
  }
  return maxResidual;
}

export function searchBounds(x0, y0, maxValue, dx, unsorted_pTimes, activeStationMarkers) {
  const seen = new Set();
  const q = [[x0, y0]];
  const good = [];

  let counter = 0;
  while (q.length > 0 && counter < 1000000) {
    counter++;
    const loc = q[0]; //pop()
    q.shift();
    const x0 = loc[0];
    const y0 = loc[1];

    const hash = x0.toString() + '_' + y0.toString();
    if (seen.has(hash)) {
      continue;
    }
    seen.add(hash);

    const value = getMaxResidual(x0, y0, unsorted_pTimes, activeStationMarkers);

    if (value < maxValue) {
      good.push([x0, y0]);
    }

    q.push(
      ...[
        [x0 + dx, y0],
        [x0, y0 + dx],
        [x0 + dx, y0 + dx],
        [x0 - dx, y0],
        [x0, y0 - dx],
        [x0 - dx, y0 - dx],
        [x0 + dx, y0 - dx],
        [x0 - dx, y0 + dx]
      ]
    );
  }

  return good;
}

export function getRandPointNearCenter(map) {
  const bounds = map.getBounds();
  const ne = bounds.getNorthEast();
  const sw = bounds.getSouthWest();

  const lat = map.getCenter().lat + ((Math.random() - 0.5) * (ne.lat - sw.lat)) / 5;
  const lng = map.getCenter().lng + ((Math.random() - 0.5) * (ne.lng - sw.lng)) / 5;

  return { lat: lat, lng: lng };
}
